// extracted by mini-css-extract-plugin
module.exports = {"root":"Switch_root__3LCD4","item":"Switch_item__rQXGm","active":"Switch_active__bH1wO"};